import Typography from '@mui/material/Typography';

export const NoForms = () => {
  return <Typography>There are no forms matching the search.</Typography>;
};
